import React from 'react'

import { useParams, useNavigate } from 'react-router-dom'

import { useFindTask } from '@hooks/task/find'

import { useGetLinks } from './links'
import { BoldText, InfoContainer, Link, Paper, RegularText } from './styles'

export function MidstreamCard() {
  const { taskId } = useParams<{ taskId: string }>()
  const { data: rawTask } = useFindTask(Number(taskId))
  const task = rawTask ?? ({} as NonNullable<typeof rawTask>)
  const { getNotificationURL, getWorkOrderURL } = useGetLinks()

  function openNotificationURL() {
    const notificationURL = getNotificationURL(task.notification ?? '')
    window.open(notificationURL, '_blank')
  }

  function openWorkOrderURL() {
    const workOrderURL = getWorkOrderURL({
      code: task.code ?? '',
      workOrder: task.workOrder ?? '',
    })

    window.open(workOrderURL, '_blank')
  }

  return (
    <Paper>
      <BoldText>{task?.jobName}</BoldText>
      <InfoContainer>
        <RegularText>Area </RegularText>
        <BoldText>{task?.area?.description}</BoldText>
      </InfoContainer>
      <InfoContainer>
        <RegularText>Equipment </RegularText>
        <BoldText>{task.equipmentTag}</BoldText>
      </InfoContainer>
      <InfoContainer>
        <RegularText>Equipment Description </RegularText>
        <BoldText>{task.equipmentDescription}</BoldText>
      </InfoContainer>
      <InfoContainer>
        <RegularText>Lead Supervisor </RegularText>
        <BoldText>{task.leadSupervisor?.description}</BoldText>
      </InfoContainer>
      <InfoContainer>
        <RegularText>Functional Location </RegularText>
        <BoldText>{task?.functionalLocation}</BoldText>
      </InfoContainer>
      <InfoContainer>
        <RegularText>WO </RegularText>
        <button onClick={openWorkOrderURL}>
          <Link>{task.workOrder ? `#${task.workOrder}` : ''}</Link>
        </button>
      </InfoContainer>
      <InfoContainer>
        <RegularText>Notification </RegularText>
        <button onClick={openNotificationURL}>
          <Link>{task.workOrder ? `#${task.workOrder}` : ''}</Link>
        </button>
      </InfoContainer>
    </Paper>
  )
}
